module.exports = __webpack_public_path__ + "static/media/question-circle-solid.137471a6.svg";